import { ComponentProperties } from "../../../../route/shared/projects/project/overview/components/StandardSpecificSection/types";
import { Column, Row } from "../../../layout";
import { BNGUnitsKPI } from "../BNGUnitsKPI";
import { ProjectPhaseKPI } from "../ProjectPhaseKPI";
import { TotalCarbonImpactKPI } from "../TotalCarbonImpactKPI";
import { VerifiedPendingKPI } from "../VerifiedPendingKPI";

interface KPIGroupProps {
  projectPhase: string | null;
  projectStatus: string;
  carbonImpactType: ComponentProperties | undefined;
  carbonImpactValue: number;
  unitMeasurement: string;
  totalUnits: number;
  standardUuid: string;
  hasVeifiedPendingKPI?: boolean;
  verifiedUnits: number;
  pendingUnits: number;
}

export const KPIGroup = ({
  projectPhase,
  projectStatus,
  carbonImpactType,
  carbonImpactValue,
  unitMeasurement,
  totalUnits,
  standardUuid,
  hasVeifiedPendingKPI = false,
  verifiedUnits,
  pendingUnits,
}: KPIGroupProps): JSX.Element => {
  return (
    <div className="KPIGroup">
      {pendingUnits === 0 && verifiedUnits === 0 ? (
        <Row>
          {carbonImpactType && unitMeasurement === "Carbon" && (
            <Column span={6}>
              <TotalCarbonImpactKPI carbonImpactValue={carbonImpactValue} carbonImpactType={carbonImpactType} />
            </Column>
          )}
          {unitMeasurement === "Biodiversity" && (
            <Column span={6}>
              <BNGUnitsKPI units={totalUnits} />
            </Column>
          )}
          <Column
            span={(carbonImpactType && unitMeasurement === "Carbon") || unitMeasurement === "Biodiversity" ? 6 : 12}
          >
            <ProjectPhaseKPI status={projectStatus} phase={projectPhase} />
          </Column>
        </Row>
      ) : (
        <Row>
          <Column span={4}>
            <ProjectPhaseKPI status={projectStatus} phase={projectPhase} />
          </Column>
          <Column span={4}>
            <TotalCarbonImpactKPI carbonImpactValue={carbonImpactValue} carbonImpactType={carbonImpactType} />
          </Column>
          {hasVeifiedPendingKPI && (
            <Column span={4}>
              <VerifiedPendingKPI
                verifiedUnits={verifiedUnits}
                pendingUnits={pendingUnits}
                standardUuid={standardUuid}
              />
            </Column>
          )}
        </Row>
      )}
    </div>
  );
};
